"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function HeldLicenseDelete(row) {
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  var quantity = (0, _get2["default"])(row, 'quantity');
  if (targetEntity && quantity !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted all ", quantity, " license", quantity === 1 ? '' : 's', " from ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted all licenses from ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (quantity !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted all ", quantity, " license", quantity === 1 ? '' : 's', " from an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted all licenses from an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
    type: "Group"
  }));
}
var _default = exports["default"] = HeldLicenseDelete;